import React from 'react';
import {
  readCurrentParkUuid,
  readCurrentTenantUuid,
} from '@/adapters/tenantStorage';

export const readActiveParkUuid = () =>
  readCurrentParkUuid(readCurrentTenantUuid());

export const readActiveContext = () => ({
  tenantUuid: readCurrentTenantUuid(),
  parkUuid: readActiveParkUuid(),
});

export const sameActiveContext = (snapshot: {
  tenantUuid: string | null;
  parkUuid: string | null;
}) => {
  const current = readActiveContext();
  return (
    current.tenantUuid === snapshot.tenantUuid &&
    current.parkUuid === snapshot.parkUuid
  );
};

export const useParkTenantContextKey = () => {
  const [contextKey, setContextKey] = React.useState(
    () => `${readCurrentTenantUuid() || ''}:${readActiveParkUuid() || ''}`,
  );

  React.useEffect(() => {
    const handleContextChange = () => {
      setContextKey(
        `${readCurrentTenantUuid() || ''}:${readActiveParkUuid() || ''}`,
      );
    };
    window.addEventListener('park-context-changed', handleContextChange);
    window.addEventListener('tenant-context-changed', handleContextChange);
    return () => {
      window.removeEventListener('park-context-changed', handleContextChange);
      window.removeEventListener('tenant-context-changed', handleContextChange);
    };
  }, []);

  return contextKey;
};
